<template>
  <v-container pb-0 class="pm-xs-container">
    <v-layout row wrap align-xs-top align-md-center mt-4 class="pm-xs-account">
      <v-flex xl2 lg3 md4 sm5 xs7 class="pm-xs-avatar">
        <v-layout row v-if="this.$store.state.userData.points === 'none'">
          <v-flex xs12 class="text-xs-left">
            <v-avatar size="50" class="pm-avatar">
              <v-icon large>person</v-icon>
            </v-avatar>
            <v-btn flat class="user-reg" @click="performLogin">
              {{ $t('auth.auth') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row spacer v-else>
          <v-flex xs12 class="text-xs-left pm-logged">
            <v-avatar size="50" class="pm-avatar">
              <img :src="this.$store.state.userData.thumbnail" v-if="this.$store.state.userData.thumbnail">
              <v-icon v-else x-large>person</v-icon>
            </v-avatar>
            <span class="user-name">
            {{ this.$store.state.userData.firstName }} {{ this.$store.state.userData.lastName }}
          </span>
            <v-btn :ripple="false" flat class="logout" @click="performLogout">
              {{ $t('account.logout') }}
            </v-btn>
            <input class="sp_push_custom_data" type="hidden" name="Name" :value="Vue.$store.state.userData.firstName">
            <input class="sp_push_custom_data" type="hidden" name="Email" :value="Vue.$store.state.userData.email">
            <input class="sp_push_custom_data" type="hidden" name="Last_name" :value="Vue.$store.state.userData.lastName">
          </v-flex>
        </v-layout>
        <login-modal/>
        <reg-modal/>
        <recovery/>
      </v-flex>
      <v-flex xl2 lg3 md4 sm5 xs5 offset-xl8 offset-lg6 offset-md4 offset-sm2 class="text-sm-right pm-xs-points">
        <v-layout row wrap align-center v-if="this.$store.state.userData.points !== 'none'">
          <v-flex xs12 md6>
            <div class="user-points">
              <span>&nbsp;{{ this.$store.state.userData.points }}</span> {{ $t('account.points') }}
            </div>
          </v-flex>
          <v-flex xs12 md6>
            <div class="user-emoney">
              {{ this.$store.state.userData.eMoney || 0 }}
              <img src="/static/images/elei.svg" alt="" />
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoginModal from './LoginModal'
import RegModal from './RegModal'
import Recovery from './recovery'
import UserFunc from '@/components/partials/AuthForm'

export default {
  name: 'userAccount',
  data () {
    return {
      Vue: this
    }
  },
  components: {
    LoginModal,
    RegModal,
    Recovery
  },
  methods: {
    performLogin () {
      this.$store.commit('var', { type: 'authVar', i: 'login', v: true })
    },
    performLogout () {
      UserFunc.logOut(this)
    }
  },
  created: function () {
    let Vue = this
    UserFunc.userLoad(Vue)
  }
}
</script>

<style>
.pm-logged {
  position: relative;
}
.pm-logged .logout {
  position: absolute;
  top: 20px;
  left: 28px;
  bottom: 5px;
  padding: 0;
}
@media (max-width: 600px) {
  .pm-xs-account {
    margin-top: 0 !important;
  }
  .pm-xs-avatar .user-name {
    margin-left: 5px;
  }
  .pm-xs-points .user-points {
    text-align: right;
    font-size: 14px;
  }

  .pm-xs-account .pm-logged  .logout {
    top: 25px;
  }

  .pm-xs-container {
    background-color: rgba(0, 4, 43, 0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/AuthForm/userAccount.vue